import { baseThemeValues } from 'constants/common';

const titleFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '13px',
  fontWeight: 500,
};

const descriptionFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '12px',
  fontWeight: 400,
};

const cardBaseProps = {
  borderRadius: '8px',
  borderWidth: '1px',
};

const indicatorBaseProps = {
  borderRadius: '50%',
};

export const radioCardGroupTheme = {
  active: {
    ...cardBaseProps,
    bg: 'palette.primary.10:0.6',
    borderColor: 'palette.primary.50',
  },
  base: {
    ...cardBaseProps,
    bg: 'palette.transparent',
    borderColor: 'palette.tertiary.40',
  },
  description: {
    ...descriptionFont,
    text: 'palette.tertiary.60',
  },
  hover: {
    ...cardBaseProps,
    bg: 'palette.tertiary.20:0.3',
    borderColor: 'palette.tertiary.50',
  },
  indicator: {
    active: {
      ...indicatorBaseProps,
      borderColor: 'palette.primary.50',
      borderWidth: '6px',
    },
    base: {
      ...indicatorBaseProps,
      borderColor: 'palette.tertiary.50',
      borderWidth: '2px',
    },
  },
  title: {
    ...titleFont,
    text: 'palette.tertiary.95',
  },
};
